interface ShouldShowShipperCompanyNameProps {
  isSubscribed: boolean;
  isPartnerShipment: boolean;
  isBookedByCarrier: boolean;
}

/*
  The shipper company name is hidden from carriers who are not partnered with the
  shipper and not on a paid subscription, until they book the shipment. "Subscribed"
  here means a recurring paid carrier plan (see hasPaidCarrierSubscription) and
  excludes pay-per-booking and free/essentials carriers.

  This is a frontend UX gate only: the backend still returns the shipper company
  name in the API response, so it is not a server-side privacy guarantee.

  One surface cannot rely on this gate and enforces the same rule server-side:
  the submit-quote command-link preview
  (application/commandLink/command_links/submit_quote/submit_quote_command_link.py,
  _carrier_may_see_shipper_company), whose client is unauthenticated and so has no
  subscription to check. Change the rule here and change it there too.
*/
export function shouldShowShipperCompanyName(
  props: ShouldShowShipperCompanyNameProps,
): boolean {
  const { isSubscribed, isPartnerShipment, isBookedByCarrier } = props;
  return isSubscribed || isPartnerShipment || isBookedByCarrier;
}
